import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/material.module';
import { PatientService } from '../patient.service';
import { bloodGroup, GenderList, MaritalStatus, salute } from 'src/app/common/types/common';
import { CommonModule, DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { ToastrService } from 'ngx-toastr';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { WebcamDialogComponent } from '../../dialogs/webcam-dialog/webcam-dialog.component';
import { TablerIconsModule } from 'angular-tabler-icons';
import { AddressDetailComponent } from "./address-detail/address-detail.component";
import { ContactDetailComponent } from "./contact-detail/contact-detail.component";
import { ValidationUtils } from 'src/app/common/validation/validation-utils';
import { MY_FORMATS } from 'src/app/common/dateFormat';
import { AppointmentDialog } from '../../dialogs/confirmation-appointment/appointment-dialog.component';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { FallbackImageDirective } from 'src/app/common/directive/fallback-image.directive';
import * as constants from 'src/app/common/constant/constants.type'
import { CommonDropDown, SingleCommonDropDown } from 'src/app/common/types/dropdown.type';
import { LookupService } from 'src/app/services/lookup.service';
import { finalize, forkJoin, Subject, take } from 'rxjs';
import { AllowOnlyDigitsDirective } from 'src/app/common/directive/allow-only-digits.directive';
import { IPatientInfo } from '../ipatient-info';
import { TranslationUtils } from 'src/app/common/utils/translation.utils';
import { ExternalEntitiesComponent } from '../../dialogs/external-entities/external-entities.component';
import { ExternalEntitiesType, ExternalEntitiesTypeLabels } from 'src/app/common/enums/external-entities-type';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

@Component({
  selector: 'app-detail',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    MatMenuModule,
    TablerIconsModule,
    FormsModule,
    AddressDetailComponent,
    ContactDetailComponent,
    TranslateModule,
    FallbackImageDirective,
    AllowOnlyDigitsDirective
  ],
  templateUrl: './patient-detail.component.html',
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  styleUrl: './patient-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PatientDetailComponent implements OnInit {

  imageUrl: string | ArrayBuffer | null = null;
  patientForm: FormGroup;
  patientfill: IPatientInfo;
  bloodgroupdetails = bloodGroup;
  Salutes = salute;
  minDate: Date;
  maxDate: Date = new Date();
  selectedImage: File | null = null;
  showAddPhotoOverlay = false;
  defaultAvatarPath = 'assets/images/profile/user-1.jpg';
  Imagefilename: string;
  listOfGender = GenderList;
  listOfMaritalStatus = MaritalStatus;
  staticimagepath: string = environment.imagePath;
  patientdata: IPatientInfo;
  educationList: SingleCommonDropDown[] = [];
  filteredEducationList: SingleCommonDropDown[] = [];
  allergyList: SingleCommonDropDown[] = [];
  filteredAllergyList: SingleCommonDropDown[] = [];
  sensitivityList: SingleCommonDropDown[] = [];
  filteredSensitivityList: SingleCommonDropDown[] = [];
  externalEntitiesList: CommonDropDown[] = [];
  filteredExternalEntitiesList: CommonDropDown[] = [];
  familyDrInputValue: string = '';
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  ageSuggestions: string[] = [];
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger: MatAutocompleteTrigger;
  @ViewChild('familyDrInput', { read: ElementRef }) familyDrInput: ElementRef<HTMLInputElement>;
  hideData = true;
  isLoading: boolean = false;

  constructor(
    private _formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) private _data: { patient?: any, patientValue?: any, fromAppointment?: boolean },
    private _patientService: PatientService,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<PatientDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public _doctorlist: any,
    private datePipe: DatePipe,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private router: Router,
    private _lookupService: LookupService,
    private translationUtils: TranslationUtils
  ) {
    this.patientfill = this._data?.patient;
    this.minDate = new Date(1800, 0, 1);

  }

  ngOnInit(): void {

    this.patientdata = {
      id: 0,
      firstName: '',
      lastName: '',
      birthDate: '',
      age: '',
      salute: '',
      maritalStatus: this.listOfMaritalStatus[0].name,
      education: '',
      bloodGroup: '',
      weight: '',
      familyDr: '',
      allergy: '',
      sensitivity: '',
      bloodPressure: '',
      middleName: '',
      gender: this.listOfGender[0].value,
      address: [],
      contactInfo: [],
      profileImagePath: '',
      aadhaarNumber: ''
    };
    // direct Add into Appointment
    if (this._data?.patientValue) {
      this.patientdata.firstName = this._data.patientValue || '';
    }
    //fetching update data 
    if (this._data?.patient?.id) {
      this.isLoading = true;
      this._patientService.getPatientByID(this._data?.patient?.id)
        .pipe(finalize(() => {
          this.isLoading = false;
          this.cdr.detectChanges();
        }))
        .subscribe((response) => {
          this.patchPatientData(response.result)
        })
    };
    this.loadAllLookups();
  }

  onSavePatient() {
    if (this.patientdata.birthDate) {
      this.patientdata.birthDate = this.datePipe.transform(this.patientdata.birthDate, constants.DATE_FORMAT) as string;
    }

    const formValues = this.patientdata;
    const formData = new FormData();

    // List of fields to exclude from the loop (address, contactInfo)
    const excludeFields = ['address', 'contactInfo'];

    // Loop through the properties of the model
    Object.keys(formValues).forEach((key) => {
      if (!excludeFields.includes(key)) {
        let value = (formValues as any)[key] || '';
        if (key === 'familyDr' && typeof value === 'object' && value !== null && value.name) {
          value = value.name;
        }
        formData.append(key, value.toString());
      }
    });
    this.appendObjectArrayToFormData(formData, this.patientdata.address, 'Addresses');
    this.appendObjectArrayToFormData(formData, this.patientdata.contactInfo, 'ContactInfo');

    // Profile Image
    if (this.selectedImage) {
      formData.append("profileImage", this.selectedImage);
    }

    this.isLoading = true;
    this._patientService.createPatient(formData)
      .pipe(finalize(() => {
        this.isLoading = false;
        this.cdr.detectChanges();
      }))
      .subscribe((response) => { // formdata Enter empty form
        if (response.isSuccess) {
          this.dialogRef.close(response);
          this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.CREATE', this.translate.instant('ENTITY.PATIENT')));
          if (!this._data?.patientValue && this._doctorlist?.isDoctorAvailable) {
            const dialogRefappointment = this.dialog.open(AppointmentDialog, {
              width: '400px',
              data: { message: this.translate.instant('APPOINTMENT_RELATED.APPOINTMENT_QUETION'), title: this.translate.instant('ENTITY.APPOINTMENT') }
            });

            dialogRefappointment.afterClosed().subscribe(result => {
              if (result === 'yes') {
                this.router.navigate(['appointment', response.result.id, 'patient']); // adjust path as needed
              }
            });
          }
        }
        else {
          const allErrors = Object.values(response.errors).flat();
          this.toastr.error(allErrors.join("\n"));
        }
      });

  }

  onUpdatePatient() {
    if (this.patientdata.birthDate) {
      this.patientdata.birthDate = this.datePipe.transform(this.patientdata.birthDate, constants.DATE_FORMAT) as string;
    }

    if (this.patientdata.contactInfo[0].email && !ValidationUtils.isValidEmail(this.patientdata.contactInfo[0].email)) {
      this.toastr.error(this.translate.instant('VALIDATION.EMAIL'));
      return;
    }
    const formValues = this.patientdata;
    const formData = new FormData();
    formData.append('id', this._data?.patient?.id);
    // List of fields to exclude from the loop (address, contactInfo)
    const excludeFields = ['address', 'contactInfo'];

    // Loop through the properties of the model
    Object.keys(formValues).forEach((key) => {
      if (!excludeFields.includes(key)) {
        let value = (formValues as any)[key] || '';
        if (key === 'familyDr' && typeof value === 'object' && value !== null && value.name) {
          value = value.name;
        }
        formData.append(key, value.toString());
      }
    });

    this.appendObjectArrayToFormData(formData, this.patientdata.address, 'Addresses');
    this.appendObjectArrayToFormData(formData, this.patientdata.contactInfo, 'ContactInfo');

    // Profile Image
    if (this.selectedImage) {
      formData.append("profileImage", this.selectedImage);
    } else {
      formData.append("profileImage", this._data?.patient?.profileImage || '');
    }


    this.isLoading = true;
    this._patientService.updatePatient(formData)
      .pipe(finalize(() => {
        this.isLoading = false;
        this.cdr.detectChanges();
      }))
      .subscribe((response) => {
        if (response.isSuccess) {
          this.dialogRef.close(response);
          this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.UPDATE', this.translate.instant('ENTITY.PATIENT')));
        }
        else {
          const allErrors = Object.values(response.errors).flat();
          this.toastr.error(allErrors.join("\n"));
        }
      });
  }

  //auto calculate age
  calculateAge(dob: Date) {
    if (!dob) return;
    const today = new Date();
    const birthDate = new Date(dob);

    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();

    // Adjust days/months
    if (days < 0) {
      months--;
      const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += lastMonth.getDate();
    }

    // Adjust months/years
    if (months < 0) {
      years--;
      months += 12;
    }

    let ageString = '';

    if (years > 0) {
      const yearLabel = years === 1 ? 'year' : 'years';
      const monthLabel = months === 1 ? 'month' : 'months';
      ageString = `${years} ${yearLabel} ${months} ${monthLabel}`;
    } else {
      // Only months if less than 1 year
      const monthLabel = months === 1 ? 'month' : 'months';
      ageString = `${months} ${monthLabel}`;
    }

    this.patientdata.age = ageString;
  }


  onCloseDialog(): void {
    this.dialogRef.close();
  }

  openMenu(trigger: MatMenuTrigger) {
    trigger.openMenu();
  }

  onFileChanged(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length > 0) {
      const file = target.files[0];
      this.Imagefilename = file.name;// name fetch mate chnage if we any thing as into file 
      const reader = new FileReader();
      this.selectedImage = file;
      reader.onload = () => {
        this.imageUrl = reader.result;
        this.cdr.detectChanges();
      };
      reader.readAsDataURL(file);
    }
  }

  takePhotoOnWebCamera() {
    this.showAddPhotoOverlay = false;
    const dialogRef = this.dialog.open(WebcamDialogComponent, {
      width: '500px',
      height: 'auto',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result._imageAsDataUrl) {
          this.imageUrl = result._imageAsDataUrl;
          this.Imagefilename = constants.DEFAULT_WEB_CAM_NAME; // Set a default name for the webcam image
          this.selectedImage = this.dataURLtoFile(result._imageAsDataUrl, this.Imagefilename);
          this.cdr.detectChanges();
        }

      }
    });
  }

  onMenuClosed() {
    this.showAddPhotoOverlay = false;
  }

  dataURLtoFile(dataurl: string, filename: string): File {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)?.[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  appendObjectArrayToFormData(
    formData: FormData,
    array: any[],
    baseKey: string
  ) {
    array.forEach((obj, index) => {
      Object.keys(obj).forEach((key) => {
        const value = obj[key] !== null && obj[key] !== undefined ? obj[key] : '';
        formData.append(`${baseKey}[${index}].${key}`, value.toString());
      });
    });
  }

  isSaveDisabled(): boolean {
    const { firstName, lastName, birthDate, contactInfo, address, aadhaarNumber } = this.patientdata || {};

    if (!firstName?.trim() || !lastName?.trim() || !birthDate || (aadhaarNumber && aadhaarNumber.length !== 12)) {
      return true;
    }

    // Validate contactInfo[0] and contactInfo[1]
    const contact0 = contactInfo?.[0]?.contact;
    const contact1 = contactInfo?.[1]?.contact;
    const isContact0Valid = !contact0 || constants.ValidationPatterns.phone.test(contact0);
    const isContact1Valid = !contact1 || constants.ValidationPatterns.phone.test(contact1);

    // Validate address[0] (Permanent)
    const addr0 = address?.[0] || {};
    const isPincode0Valid = !addr0.pincode || constants.ValidationPatterns.pincode.test(addr0.pincode);
    const isCountry0Valid = !addr0.country || constants.ValidationPatterns.alphabets.test(addr0.country);
    const isState0Valid = !addr0.state || constants.ValidationPatterns.alphabets.test(addr0.state);
    const isDistrict0Valid = !addr0.district || constants.ValidationPatterns.alphabets.test(addr0.district);
    const isTaluka0Valid = !addr0.taluka || constants.ValidationPatterns.alphabets.test(addr0.taluka);
    const isArea0Valid = !addr0.area || constants.ValidationPatterns.alphabets.test(addr0.area);

    // Validate address[1] (Current)
    const addr1 = address?.[1] || {};
    const isPincode1Valid = !addr1.pincode || constants.ValidationPatterns.pincode.test(addr1.pincode);
    const isCountry1Valid = !addr1.country || constants.ValidationPatterns.alphabets.test(addr1.country);
    const isState1Valid = !addr1.state || constants.ValidationPatterns.alphabets.test(addr1.state);
    const isDistrict1Valid = !addr1.district || constants.ValidationPatterns.alphabets.test(addr1.district);
    const isTaluka1Valid = !addr1.taluka || constants.ValidationPatterns.alphabets.test(addr1.taluka);
    const isArea1Valid = !addr1.area || constants.ValidationPatterns.alphabets.test(addr1.area);

    // Return true (disable button) if any validation fails
    return !(
      isContact0Valid &&
      isContact1Valid &&
      isPincode0Valid &&
      isCountry0Valid &&
      isState0Valid &&
      isDistrict0Valid &&
      isTaluka0Valid &&
      isArea0Valid &&
      isPincode1Valid &&
      isCountry1Valid &&
      isState1Valid &&
      isDistrict1Valid &&
      isTaluka1Valid &&
      isArea1Valid
    );
  }

  private patchPatientData(patient: IPatientInfo) {
    this.patientdata = {
      id: patient?.id || 0,
      firstName: patient?.firstName || this._data.patientValue, // patientValue direct Add into Appointment
      lastName: patient?.lastName || '',
      birthDate: patient?.birthDate || '',
      age: patient?.age || '',
      salute: patient.salute || '',
      maritalStatus: patient?.maritalStatus || 'Unmarried',
      education: patient?.education || '',
      bloodGroup: patient?.bloodGroup || '',
      weight: patient?.weight || '',
      familyDr: patient?.familyDr || '',
      allergy: patient?.allergy || '',
      sensitivity: patient?.sensitivity || '',
      bloodPressure: patient?.bloodPressure || '',
      middleName: patient?.middleName || '',
      gender: patient?.gender || 'M',
      address: patient?.address || [],
      contactInfo: patient?.contactInfo || [],
      profileImagePath: patient?.profileImagePath,
      aadhaarNumber: patient?.aadhaarNumber || ''
    };
    if (patient?.birthDate) {
      this.calculateAge(new Date(patient.birthDate));
    }
    this.cdr.detectChanges();
  }

  get profileImagePathSrc(): string {
    if (this.imageUrl) {
      return this.imageUrl as string;
    }
    if (this.patientfill?.profileImagePath) {
      return this.staticimagepath + this.patientfill.profileImagePath;
    }
    return this.defaultAvatarPath;
  }

  loadAllLookups(entityType?: ExternalEntitiesType): void {
    this.isLoading = true;
    forkJoin({
      education: this._lookupService.education$.pipe(take(1)),
      allergy: this._lookupService.allergy$.pipe(take(1)),
      sensitivity: this._lookupService.sensitivity$.pipe(take(1)),
      externalEntities: this._lookupService.getExternalEntities(ExternalEntitiesType.FamilyDoctor).pipe(take(1)),
    })
      .pipe(finalize(() => {
        this.isLoading = false;
        this.cdr.detectChanges();
      }))
      .subscribe({
        next: (res) => {
          if (res.education) {
            this.educationList = this.filteredEducationList = res.education;
          }
          if (res.allergy) {
            this.allergyList = this.filteredAllergyList = res.allergy;
          }
          if (res.sensitivity) {
            this.sensitivityList = this.filteredSensitivityList = res.sensitivity;
          }
          if (res.externalEntities) {
            this.externalEntitiesList = this.filteredExternalEntitiesList = res.externalEntities;
          }
        },
        error: (err) => console.error('Failed to load lookup lists:', err),
      });
  }

  filterLookup(event: Event, type: 'education' | 'allergy' | 'sensitivity' | 'externalEntities'): void {
    const value = (event.target as HTMLInputElement).value.toLowerCase();
    switch (type) {
      case 'education':
        this.filteredEducationList = this.educationList.filter(x => x.value?.toLowerCase().includes(value));
        break;

      case 'allergy':
        this.filteredAllergyList = this.allergyList.filter(x => x.value?.toLowerCase().includes(value));
        break;

      case 'sensitivity':
        this.filteredSensitivityList = this.sensitivityList.filter(x => x.value?.toLowerCase().includes(value));
        break;

      case 'externalEntities':
        this.filteredExternalEntitiesList = this.externalEntitiesList.filter(x => x.name?.toLowerCase().includes(value));
        break;
    }
  }

  onFamilyDrInput(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.familyDrInputValue = inputValue;
    this.filterLookup(event, 'externalEntities');
    this.cdr.detectChanges();
  }

  shouldShowAddOption(): boolean {
    if (!this.familyDrInputValue || !this.familyDrInputValue.trim()) {
      return false;
    }
    const trimmedValue = this.familyDrInputValue.trim().toLowerCase();
    const exists = this.externalEntitiesList.some(
      entity => entity.name?.toLowerCase() === trimmedValue
    );
    return !exists;
  }

  calculateDateOfBirth(input: string) {
    if (!input) {
      this.ageSuggestions = [];
      return;
    }

    const value = input.trim().toLowerCase();
    this.ageSuggestions = [];

    const formatAge = (years: number, months: number) => {
      const yearText = years ? `${years} year${years > 1 ? 's' : ''}` : '';
      const monthText = months ? `${months} month${months > 1 ? 's' : ''}` : '';
      return [yearText, monthText].filter(Boolean).join(' ');
    };

    if (value.includes('m')) {
      const months = Number(value.match(/\d+/)?.[0]);
      if (!months || months < 0) {
        return
      };
      this.ageSuggestions.push(formatAge(0, months));
      return;
    }

    if (value.includes('y')) {
      const years = Number(value.match(/\d+/)?.[0]);
      if (!years || years < 0) {
        return;
      }
      for (let m = 0; m <= 11; m++) {
        this.ageSuggestions.push(formatAge(years, m));
      }
      return;
    }

    //fallback : if user just types number like "1"
    const num = Number(value);
    if (!num || num < 0) {
      return;
    }
    // treat numbers < 12 as months
    if (num < 12) {
      this.ageSuggestions.push(formatAge(0, num));
    } else {
      // treat ≥ 1 as years
      for (let m = 0; m <= 11; m++) {
        this.ageSuggestions.push(formatAge(num, m));
      }
    }
  }

  onAgeSuggestionSelected(value: string) {
    this.patientdata.age = value;
    this.ageSuggestions = [];

    let years = 0;
    let months = 0;

    // match year part
    const yearMatch = value.match(/(\d+)\s*year/);
    if (yearMatch) {
      years = Number(yearMatch[1]);
    }

    // match month part
    const monthMatch = value.match(/(\d+)\s*month/);
    if (monthMatch) {
      months = Number(monthMatch[1]);
    }

    const today = new Date();
    const birthDate = new Date(
      today.getFullYear() - years,
      today.getMonth() - months,
      today.getDate()
    );

    this.patientdata.birthDate =
      this.datePipe.transform(birthDate, constants.DATE_FORMAT) as string;
  }

  trimName(field: 'firstName' | 'middleName' | 'lastName'): void {
    this.patientdata[field] = this.patientdata[field]?.trim();
  }

  addExternalEntities(prefillName?: string) {
    this.dialog.open(ExternalEntitiesComponent, {
      width: '500px',
      disableClose: true,
      data: {
        entityType: ExternalEntitiesType.FamilyDoctor,
        title: ExternalEntitiesTypeLabels[ExternalEntitiesType.FamilyDoctor],
        prefillName: prefillName || ''
      }
    }).afterClosed().subscribe((result) => {
      if (result) {
        this.externalEntitiesList.push(result);
        this.filteredExternalEntitiesList = [...this.externalEntitiesList];
        this.patientdata.familyDr = result;

        const displayValue = this.displayFamilyDr(result);
        if (this.familyDrInput?.nativeElement) {
          this.familyDrInput.nativeElement.value = displayValue;
        }
        this.loadAllLookups(ExternalEntitiesType.FamilyDoctor);

        this.cdr.detectChanges();

        setTimeout(() => {
          if (this.autocompleteTrigger) {
            this.autocompleteTrigger.closePanel(); // Force close
          }
          if (this.familyDrInput?.nativeElement) {
            this.familyDrInput.nativeElement.focus();
          }
        }, 0);
      }
    });
  }

  displayFamilyDr = (entity: any): string => {
    if (!entity) {
      return '';
    }
    if (typeof entity === 'object' && entity.name) {
      return entity.name;
    }
    return typeof entity === 'string' ? entity : '';
  };

  onFamilyDoctorSelected(value: any): void {
    // Don't process if value is null (Add option was clicked)
    if (value === null) {
      return;
    }
    this.patientdata.familyDr = value;
    this.filteredExternalEntitiesList = [...this.externalEntitiesList];
    if (value && typeof value === 'object' && value.name) {
      this.familyDrInputValue = value.name;
    } else {
      this.familyDrInputValue = '';
    }
  }
}
